<template>
  <div class="gameDetail">
    <HeadBar title="赛事详情" />
    <div class="gameContent">
      <div class="gameTop">
        <img :src="matchInfoAjax.pictureUrl" :alt="matchInfoAjax.matchName" width="100%" />
        <div class="matchName pd10">{{ matchInfoAjax.matchName }}</div>
      </div>
    </div>

    <div class="gameContent">
      <ul class="matchInfoList">
        <li>
          <van-icon name="clock-o" />
          <span>报名时间： {{ matchInfoAjax.startTime }} ~
            {{ matchInfoAjax.endTime }}</span>
        </li>
        <li>
          <van-icon name="underway-o" />
          <span>比赛时间：{{ matchInfoAjax.matchTime }}</span>
        </li>
        <li>
          <van-icon name="location-o" />
          <span>比赛地点：{{ matchInfoAjax.place }} </span>
        </li>
        <li v-if="matchInfoAjax.organizer">
          <van-icon name="medal-o" />
          <span>{{ matchInfoAjax.organizer }} </span>
        </li>
        <li v-if="matchInfoAjax.undertakingUnit">
          <van-icon name="point-gift-o" />
          <span>{{ matchInfoAjax.undertakingUnit }} </span>
        </li>
        <li v-if="matchInfoAjax.yunyingUnit">
          <van-icon name="bullhorn-o" />
          <span>{{ matchInfoAjax.yunyingUnit }} </span>
        </li>
        <li v-if="matchInfoAjax.zhichiUnit">
          <van-icon name="friends-o" />
          <span>{{ matchInfoAjax.zhichiUnit }} </span>
        </li>
      </ul>
    </div>

    <div class="gameContent">
      <van-tabs v-model="active">
        <van-tab title="比赛项目">
          <ul class="gameProject">
            <li v-for="(item, index) in projectList" :key="index">
              <a @click="goLink(item, index)" class="projectItem">
                <div class="projectName">{{ item.projectName }}</div>
                <div class="projectPrice">
                  <span class="projectDesc">参赛费用</span>
                  <span class="projectType">{{item.type === 1 ? "（个人赛）" : "（团体赛）"}}</span>
                  <span v-if="item.price === 0"> 免费 </span>
                  <span v-else> &yen;{{ item.price }}元 /人</span>
                  <span class="hide">{{ item.people }}/{{ item.scale }}</span>

                  <span v-if="item.state === 1">
                    <van-button type="danger" size="small" round class="goBaoming" disabled>准备中</van-button>
                  </span>
                  <span v-else-if="item.state === 2">
                    <span v-if="item.people < item.scale">
                      <van-button type="danger" size="small" round class="goBaoming">去报名</van-button>
                    </span>
                    <span v-else>
                      <van-button type="danger" size="small" round class="goBaoming" disabled>人数已满</van-button>
                    </span>
                  </span>
                  <span v-else-if="item.state === 3">
                    <van-button type="info" size="small" round class="goBaoming" disabled>报名结束</van-button>
                  </span>
                  <span v-else-if="item.state === 4">
                    <van-button type="danger" size="small" round class="goBaoming" disabled>比赛结束</van-button>
                  </span>
                </div>
              </a>
            </li>
          </ul>
        </van-tab>
        <van-tab v-for="(item, index) in menuList" :title="item.name" :key="index">
          <NewsContent :newId="item.newSid"></NewsContent>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
  import HeadBar from "@/components/HeadBar.vue";
  import { getQueryString, fetchHttp, formatTime } from "@/util/fn.js";
  import NewsContent from "@/components/NewsContent.vue";

  import { Toast, Button, Tab, Tabs } from "vant";

  export default {
    name: "gameDetail",
    components: {
      HeadBar,
      [Button.name]: Button,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      NewsContent,
    },
    data() {
      return {
        active: 0,
        matchInfoAjax: {},
        userId: Cookies.get("USERID"),
        menuList: [],
        matchId: getQueryString("matchId"),
        online: getQueryString("online"),
        projectList: [],
        agreementNewsID: '',
      };
    },
    computed: {
    },
    mounted() {
      let id = getQueryString("matchId");
      if (id) {
        //获取赛事详情
        fetchHttp("marathon/match/getMatchInfo", { id }, "GET").then((res) => {
          if (res && res.code === 0) {
            if (res.data && res.data.matchName) {
              if (res && res.data && res.data.matchTime) {
                res.data.matchTime = formatTime(res.data.matchTime);
                res.data.endTime = formatTime(res.data.endTime);
                res.data.startTime = formatTime(res.data.startTime);
                this.endTime = res.data.endTime;
                this.matchName = res.data.matchName;
              }
              this.matchInfoAjax = res.data;
              let menuList = res.data && res.data.newsList;
              let renderMenuList = [];
              menuList.forEach((item) => {
                if (item.name === '合作伙伴') {
                  this.agreementNewsID = item.newSid;
                } else {
                  item.newSid ? renderMenuList.push(item) : "";
                }
              });
              this.menuList = renderMenuList;
              console.log("matchInfoAjax", this.matchInfoAjax);
            } else {
              Toast("没有找到相关赛事");
            }
          }
        });
        //获取项目信息
        fetchHttp("marathon/project/information", { matchId: id }, "GET").then(
          (res) => {
            if (res && res.code === 0) {
              let projectList = [];
              res.data &&
                res.data.length > 0 &&
                res.data.map((item, index) => {
                  console.log(1111, item);
                });
              this.projectList = res.data;
            }
          }
        );
      } else {
        Toast("没有找到相关的赛事项目");
      }
    },
    methods: {
      goLink(item, index) {
        let baomingHref = `gameSignUp?matchId=${this.matchId}&matchName=${this.matchName
          }&projectId=${item.id}&index=${index}&online=${this.online
          }&endTime=${formatTime(this.endTime)}`;
        if (item.price) {
          baomingHref += `&price=${item.price}`;
        }
        //如果有免责声明，就用他的，没有就默认
        if (this.agreementNewsID) {
          baomingHref += `&agreementNewsId=${this.agreementNewsID}`;
        }
        //检查登陆
        this.checkLogin(() => {
          if (item.state === 2) {
            if (item.people == item.scale) {
              Toast("该项目报名人数已满，看看其他项目吧！");
              return false;
            } else {
              window.location.href = baomingHref;
            }
          } else {
            Toast("该比赛不在报名期，去赛事列表看看其他比赛吧！");
            return false;
          }
        });
      },

      checkLogin(callback) {
        //获取基本信息
        fetchHttp(
          "marathon/getUserInfo",
          { id: this.userId },
          "GET",
          "showError"
        ).then((res) => {
          if (res && res.code === 0) {
            if (callback) {
              callback();
            }
          }
        });
      },
    },
  };
</script>
<style scope lang="less">
  .baomingNum {
    font-size: 12px;
    color: #999999;
    margin-left: 5px;
  }

  .projectPrice {
    font-size: 18px;
    color: #e50021;
    /* font-family: Chalet_out; */
  }

  .projectDesc {
    font-size: 16px;
    color: #666666;
  }

  .projectName {
    font-size: 15px;
    font-weight: normal;
    border-left: 3px solid #e50021;
    padding-left: 10px;
    margin-bottom: 10px;
  }

  .matchInfoList {
    color: #333333;
    font-size: 15px;
  }

  .matchInfoList li {
    line-height: 30px;
    border-bottom: 1px solid #f1f1f1;
    margin: 5px 0;
    padding: 5px;
    position: relative;
  }

  .goBaoming {
    position: absolute;
    right: 15px;
    bottom: 10px;
    width: 70px;
  }

  .matchInfoList .van-icon {
    font-size: 18px;
    margin-right: 6px;
    vertical-align: sub;
    font-weight: bold;
    color: red;
  }

  .pd10 {
    padding: 0 10px;
  }

  .gameDetail {
    font-size: 14px;
    background-color: #f7f7f7;
  }

  .matchName {
    font-size: 16px;
    margin: 5px 0;
    width: 100%;
    background-color: #fff;
  }

  .gameTop {
    background-color: #fff;
    padding-bottom: 10px;
  }

  .gameContent {
    font-size: 16px;
    margin: 0px 0px 10px 0;
    width: 100%;
    background-color: #fff;
  }

  .gameProject {
    color: #333333;
    padding: 0 10px;
    font-size: 15px;
  }

  .gameProject a {
    color: #333333;
  }

  .gameProject li {
    width: 100%;
    border: 1px solid #f1f1f1;
    margin: 10px 0;
    padding: 10px;
    position: relative;
  }

  .projectType {
    font-size: 12px;
    color: #e50021;
  }
</style>